import React from 'react';
import { TableCell } from '@mui/material';

import { formatCurrency } from './utils';

// เซลล์ตัวเลข — จางค่าที่เป็น 0 ลง กันตาสับสนเวลากวาดหาคอลัมน์ที่มีค่าจริง
export default function NumCell({ value, emphasize }) {
  const isZero = !value;
  return (
    <TableCell
      align="right"
      sx={{
        fontVariantNumeric: 'tabular-nums',
        color: isZero ? 'text.disabled' : 'text.primary',
        fontWeight: emphasize ? 700 : 400,
      }}
    >
      {formatCurrency(value)}
    </TableCell>
  );
}
